import { getBaseMenuItems } from "./baseMenuConfig";
import { adentisMenuConfig } from "./adentisMenuConfig";
import { beeMenuConfig } from "./beeMenuConfig";
import { codewinMenuConfig } from "./codewinMenuConfig";
import { teamItMenuConfig } from "./teamitMenuConfig";
import { moongyMenuConfig } from "./moongyMenuConfig";
import { recodmeMenuConfig } from "./recodmeMenuConfig";
import { agap2MenuConfig } from "./agap2MenuConfig";
import { kcsitMenuConfig } from "./kcsitMenuConfig";
import { TENANTS } from "../../../../config/tenantConfig";
import { getCompanyTenant } from "../../../../constants/companies";

const tenantMenuConfigs = {
  [TENANTS.ADENTIS]: adentisMenuConfig,
  [TENANTS.BEE]: beeMenuConfig,
  [TENANTS.MOONGY]: moongyMenuConfig,
  [TENANTS.AGAP2]: agap2MenuConfig,
  [TENANTS.KCS]: kcsitMenuConfig,
  [TENANTS.CODEWIN]: codewinMenuConfig,
  [TENANTS.TEAMIT]: teamItMenuConfig,
  [TENANTS.RECODME]: recodmeMenuConfig
};

export const getMenuForTenant = (tenantId, t) => {
  const tenantName = getCompanyTenant(tenantId);

  const tenantConfig = tenantMenuConfigs[tenantName] || {
    additionalItems: [],
    hideItems: [],
    modifyItems: [],
  };

  const baseMenuItems = getBaseMenuItems(t);

  let menuItems = baseMenuItems.map((item) => ({
    ...item,
    children: item.children ? [...item.children] : undefined,
  }));

  if (tenantConfig.hideItems && tenantConfig.hideItems.length > 0) {
    menuItems = menuItems
      .filter((item) => !tenantConfig.hideItems.includes(item.key))
      .map((item) => {
        if (item.children) {
          const filteredChildren = item.children.filter(
            (child) => !tenantConfig.hideItems.includes(child.key)
          );
          return {
            ...item,
            children: filteredChildren,
          };
        }
        return item;
      });
  }

  if (tenantConfig.modifyItems && tenantConfig.modifyItems.length > 0) {
    tenantConfig.modifyItems.forEach((modification) => {
      const itemIndex = menuItems.findIndex(
        (item) => item.key === modification.key
      );

      if (itemIndex !== -1) {
        if (modification.addChildren && modification.addChildren.length > 0) {
          if (!menuItems[itemIndex].children) {
            menuItems[itemIndex].children = [];
          }
          menuItems[itemIndex].children = [
            ...menuItems[itemIndex].children,
            ...modification.addChildren,
          ];
        }

        Object.keys(modification).forEach((key) => {
          if (key !== "key" && key !== "addChildren") {
            menuItems[itemIndex][key] = modification[key];
          }
        });
      }
    });
  }

  if (tenantConfig.additionalItems && tenantConfig.additionalItems.length > 0) {
    menuItems = [...menuItems, ...tenantConfig.additionalItems];
  }

  return menuItems;
};

export { adentisMenuConfig, beeMenuConfig, moongyMenuConfig };
